import { useParams } from 'react-router-dom';

const GameManual = () => {
  const { phase } = useParams();
  const filename = phase ? `${phase}.pdf` : 'phase-2.pdf';

  return (
    <main>
      <div className="mx-auto max-w-screen-2xl px-8">
        <iframe src={`/${filename}`} className="w-full h-screen" />
      </div>
    </main>
  );
};

export default GameManual;
